import { createSelector } from 'reselect';
import { getFormValues, isDirty } from 'redux-form';

import { RootState } from '../../reducers';
import { getForms } from '../settings/settings.selector';
import { Forms } from '../../form/form.selector';
import { DriverPermission } from './driverPermissions.types';
import { OperatorManagementFormValues } from '../../../routes/Manage/Settings/SettingsPage/SettingsSpecificPanel/OperatorManagementPanel/OperatorManagementPanel';

export const getDriverPermissionList = (state: RootState) => state.entities.driverPermissions;

export const getUpdatedOperatorPermissionForms = createSelector(
  [getForms, (state: RootState) => state],
  (forms, state) => {
    const formNames = Object.keys(forms);
    const filteredForms = formNames.filter((form) => form.search(Forms.operatorsPermissions) !== -1);
    return filteredForms.filter((form) => isDirty(form)(state));
  },
);

export const canSaveDriverPermissions = createSelector([getForms, (state: RootState) => state], (forms, state) => {
  const formNames = Object.keys(forms);
  const filteredForms = formNames.filter((form) => form.search(Forms.operatorsPermissions) !== -1);
  const values = filteredForms.map((form) => getFormValues(form)(state)) as DriverPermission[];
  const valuesAreValid = values.some((value) => value.basic) && values.some((value) => value.standard);
  const settignValues = getFormValues(Forms.operatorsPermissions)(state) as OperatorManagementFormValues;
  const driverUsePermissions = settignValues?.driverUsePermissions;
  const canSave = !driverUsePermissions || valuesAreValid;
  return canSave;
});
